import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    colorPrimary: {
        backgroundColor: '#E5E5E5',
    },
    barColorPrimary: {
        backgroundColor: '#109CF1',
    },
    mobileCard: {
      background: 'white',
      borderRadius: '16px',
      padding: 15,
      margin: 10,
      border: '3px white solid',
    },
    flexLine: {
      display: 'flex',
      alignItems: 'center',
      margin: '10px 0',
    },
    wrapper: {
        margin: 20,
        overflow: 'visible',
    },
    card: {
        padding: '10px 0',
        background: 'white',
        borderRadius: '16px',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    },
    card__wrapper: {
        padding: '0 10px',
    },
    card__header: {
        display: 'flex',
        '&>*:first-child': {
        display: 'flex',
        alignItems: 'center',
        width: '40%',
        },
        '&>*:last-child': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        paddingRight: 20,
        width: '60%',
        },
        alignItems: 'center',
        paddingBottom: 10,
        '& .MuiChip-root': {
        height: 25,
        },
    },
    heading: {
        padding: '0 15px 0 16px',
        fontWeight: 700,
        fontSize: 25,
        color: '#58595B',
        margin: '10px 0 10px 0',
    },
    searchTable: {
        display: 'block',
        maxWidth: '100%',
        marginTop: '5px',
        overflowX: 'scroll',
    },
    noContentBlock: {
        minHeight: 200,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    arrowButton: {
        padding: 0,
        marginLeft: 0,
        marginRight: 6,
    },
    flexLineDefault: {
      display: 'flex',
      alignItems: 'center',
    },
    prLink: {
        overflow: 'hidden',
        color: '#00b5e2',
    },
    center: {
      textAlign: 'center',
      maxWidth: '100%',
    },
    full: {
      width: '100%',
    },
    topLogo: {
      textAlign: 'center',
      height: 75,
      width: 75,
      marginTop: -37.5,
    },
    paragraph: {
      fontFamily: 'Roboto Condensed',
      fontSize: 18,
      lineHeight: '25.5px',
      letterSpacing: '1%',
      color: '#4D4D4F',
      fontWeight: 300,
    },
    headingTitle: {
      fontSize: 45,
      color: '#00B5E2',
      margin: 0,
      marginTop: 15,
      fontFamily: 'Playfair Display',
    },
    bigText: {
      fontSize: 34,
      color: '#00B5E2',
      fontWeight: 700,
      fontFamily: 'Roboto',
    },
    social: {
      maxWidth: '100%',
    },
    columnTitle: {
      width: '40%',
      fontWeight: '600',
    },
    columnValue: {
      width: '60%',
    },
}));

export default useStyles;
